/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';
import type { AlertSummary } from './AlertSummary';
import {
    AlertSummaryFromJSON,
    AlertSummaryFromJSONTyped,
    AlertSummaryToJSON,
    AlertSummaryToJSONTyped,
} from './AlertSummary';

/**
 * 
 * @export
 * @interface ResponseAlertSummary
 */
export interface ResponseAlertSummary {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseAlertSummary
     */
    result: ResponseResult;
    /**
     * 
     * @type {AlertSummary}
     * @memberof ResponseAlertSummary
     */
    data: AlertSummary;
}

/**
 * Check if a given object implements the ResponseAlertSummary interface.
 */
export function instanceOfResponseAlertSummary(value: object): value is ResponseAlertSummary {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseAlertSummaryFromJSON(json: any): ResponseAlertSummary {
    return ResponseAlertSummaryFromJSONTyped(json, false);
}

export function ResponseAlertSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAlertSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': AlertSummaryFromJSON(json['data']),
    };
}

export function ResponseAlertSummaryToJSON(json: any): ResponseAlertSummary {
    return ResponseAlertSummaryToJSONTyped(json, false);
}

export function ResponseAlertSummaryToJSONTyped(value?: ResponseAlertSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': AlertSummaryToJSON(value['data']),
    };
}

